<template>
    <hm-content class="micro-goods-list">
        <div class="mb10">
            <el-radio-group
                    v-model="searchCondition.status"
                    size="small"
                    @change="switchTabs"
            >
                <el-radio-button label="1"
                >待审核({{ waitStatus.applyNum }})</el-radio-button
                >
                <el-radio-button label="2"
                >待退款({{ waitStatus.agreeNum }})</el-radio-button
                >
                <el-radio-button label="4"
                >已退款({{ waitStatus.payNum }})</el-radio-button
                >
                <el-radio-button label="8"
                >已驳回({{ waitStatus.refuseNum }})</el-radio-button
                >
                <el-radio-button label="0"
                >全部({{ waitStatus.allNum }})</el-radio-button
                >
            </el-radio-group>
        </div>
        <div class="table-panel flex flex-wrap flex-end">
            <el-select
                    clearable
                    v-model="searchCondition.storeCode"
                    placeholder="请选择分销商"
                    size="small"
                    filterable
                    class="mr10"
            >
                <el-option
                        :label="v.storeName"
                        :value="v.storeCode"
                        v-for="(v, i) in distributor"
                        :key="i"
                ></el-option>
            </el-select>
            <el-select
                    clearable
                    v-model="searchCondition.returnType"
                    placeholder="请选择退款方式"
                    size="small"
                    class="mr10"
            >
                <el-option label="仅退款" value="money"></el-option>
                <el-option label="退运费" value="deliver"></el-option>
                <el-option label="退货退款" value="refund"></el-option>
            </el-select>
            <!-- <el-select
              clearable
              v-model="searchCondition.status"
              placeholder="请选择退款状态"
              size="small"
              filterable
              class="mr10"
            >
              <el-option label="已提交" value="1"></el-option>
              <el-option label="已审核" value="2"></el-option>
              <el-option label="已退货待退款" value="3"></el-option>
              <el-option label="已退款" value="4"></el-option>
              <el-option label="已驳回" value="8"></el-option>
              <el-option label="已取消" value="9"></el-option>
            </el-select> -->
            <el-select
                    v-model="searchCondition.queryTimeType"
                    size="small"
                    style="width:101px;marginLeft:4px"
                    class="time-type"
                    filterable
            >
                <el-option label="申请时间" value="returnSendTime"></el-option>
                <el-option label="退款时间" value="refundTime"></el-option>
            </el-select>
            <el-date-picker
                    v-model="searchCondition.applyDate"
                    :default-time="['00:00:00', '23:59:59']"
                    type="datetimerange"
                    align="right"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    size="small"
                    class="mr10 time"
            ></el-date-picker>
            <el-input
                    style="width:200px"
                    class="mr10"
                    clearable
                    v-model.trim="searchCondition.queryKey"
                    placeholder="请输入退款编号/订单号"
                    size="small"
            ></el-input>
            <el-button type="primary" size="small" @click="search">查询</el-button>
            <el-button
                    type="success"
                    size="small"
                    @click="output"
                    :loading="isOutputing"
            >导出</el-button
            >
            <el-button type="info" size="small" @click="searchCondition = {}"
            >重置</el-button
            >
        </div>
        <div class="table">
            <el-table
                    stripe
                    border
                    show-summary
                    ref="brandTable"
                    @selection-change="getChecked"
                    :data="tableData"
                    style="width: 100%"
                    id="table"
                    size="small"
            >
                <!-- <el-table-column type="selection"></el-table-column> -->
                <el-table-column
                        type="index"
                        label="序号"
                        :index="index => index + (currentPage - 1) * pageSize + 1"
                ></el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="returnSn"
                        label="退款编码"
                ></el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="returnType"
                        label="退款方式"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.returnType === 'money'">仅退款</span>
                        <span v-else-if="scope.row.returnType === 'refund'">退货退款 </span>
                        <span v-else-if="scope.row.returnType === 'deliver'">退运费 </span>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="receiptSn"
                        label="订单编号"
                ></el-table-column>
                <el-table-column header-align="center" align="center" label="商品名称">
                    <template slot-scope="scope">
                        <el-tooltip
                                class="item"
                                :content="scope.row.spuName"
                                placement="top"
                        >
                            <div class="flex item-center">
                                <!-- <span class="pos" v-if="scope.row.createMode">
                                  p
                                </span> -->
                                <span class="time flex-1 text-overflow">
                  {{ scope.row.spuName }}
                </span>
                            </div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" label="商品编码">
                    <template slot-scope="scope">
                        <span>{{ scope.row.goodsSn }}</span>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" label="商品条码">
                    <template slot-scope="scope">
                        <span>{{ scope.row.barCode }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="returnAmount"
                        label="申请退款金额"
                >
                    <template slot-scope="scope">
                        <span class="danger">¥{{ scope.row.returnAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="confirmReturnAmount"
                        label="核定退款金额"
                >
                    <template slot-scope="scope">
                        <span class="danger">¥{{ scope.row.confirmReturnAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="returnDeliverMoney"
                        label="运费退款申请"
                >
                    <template slot-scope="scope">
                        <span class="danger">¥{{ scope.row.returnDeliverMoney }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="confirmReturnDeliverMoney"
                        label="运费退款核定"
                >
                    <template slot-scope="scope">
            <span class="danger"
            >¥{{ scope.row.confirmReturnDeliverMoney }}</span
            >
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="returnSendTime"
                        label="申请时间"
                ></el-table-column>
                <el-table-column header-align="center" align="center" label="退款状态">
                    <template slot-scope="scope">
                        <span class="danger" v-if="scope.row.status === 1">已提交</span>
                        <span class="danger" v-if="scope.row.status === 2">已审核</span>
                        <span class="danger" v-if="scope.row.status === 3"
                        >已退货待退款</span
                        >
                        <span class="blue" v-if="scope.row.status === 4">已退款</span>
                        <span class="gray" v-if="scope.row.status === 5">待确认</span>
                        <span class="danger" v-if="scope.row.status === 8">已驳回</span>
                        <span class="gray" v-if="scope.row.status === 9">已取消</span>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" label="退款类型">
                    <span>售后申请 </span>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="shareStoreName"
                        label="所属分销商"
                ></el-table-column>
                <el-table-column label="操作" header-align="center" align="center">
                    <template slot-scope="scope">
                        <div class="flex flex-center">
                            <el-tooltip class="item" content="查看" placement="top">
                                <div class="pointer mr10" @click="toDetails(scope.row)">
                                    <span class="hmicon icon-chakan blue"></span>
                                </div>
                            </el-tooltip>
                            <!-- <el-tooltip class="item" content="删除" placement="top">
                              <div class="pointer mr10" @click="removes(scope.row)">
                                <span class="hmicon icon-chakan blue"></span>
                              </div>
                            </el-tooltip> -->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="hm-pagination">
            <el-pagination
                    background
                    :total="total"
                    @current-change="paging"
                    @size-change="handleSizeChange"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="currentPage"
                    :page-size="pageSize"
            ></el-pagination>
        </div>
        <el-dialog
                :close-on-click-modal="false"
                width="95%"
                :visible.sync="dialogVisible"
        >
            <div slot="title">
                <span class="mr10">订单详情</span>
                <span class="form-item-tip" style="color: #fF0000"
                >当前订单状态：{{ orderSta }}</span
                >
            </div>
            <div class="content">
                <div class="flex mt10">
                    <!-- <ul class="info-list flex-1">
                      <li class="mb20">
                        <div class="title">基本信息</div>
                        <div class="mb20">
                          <el-table
                            stripe
                            border
                            :data="[detailsorderReturn.orderInfo]"
                            size="small"
                          >
                            <el-table-column
                              header-align="center"
                              align="center"
                              prop="receiptSn"
                              label="订单编号"
                            ></el-table-column>
                            <el-table-column
                              header-align="center"
                              align="center"
                              prop="orderState"
                              label="订单状态"
                            >
                              <template
                                slot-scope="scope"
                                v-if="detailsorderReturn.orderInfo"
                              >
                                <span
                                  class="status blue"
                                  v-if="scope.row.orderState === 'createOrder'"
                                  >创建订单</span
                                >
                                <span
                                  class="status blue"
                                  v-if="scope.row.orderState === 'payOrder'"
                                  >订单支付</span
                                >
                                <span
                                  class="status blue"
                                  v-if="scope.row.orderState === 'deliverOrder'"
                                  >订单发货</span
                                >
                                <span
                                  class="status blue"
                                  v-if="scope.row.orderState === 'takeOrder'"
                                  >确认收货</span
                                >
                                <span
                                  class="status blue"
                                  v-if="scope.row.orderState === 'pushOrder'"
                                  >完成评论</span
                                >
                                <span
                                  class="status blue"
                                  v-if="scope.row.orderState === 'delOrder'"
                                  >订单取消</span
                                >
                                <span
                                  class="status blue"
                                  v-if="scope.row.orderState === 'returnOrder'"
                                  >售后订单</span
                                >
                              </template>
                            </el-table-column>
                            <el-table-column
                              header-align="center"
                              align="center"
                              prop="actuallyPrice"
                              label="订单金额"
                            ></el-table-column>
                            <el-table-column
                              header-align="center"
                              align="center"
                              prop="payMode"
                              label="退货数量"
                            >
                              <template v-if="detailsorderReturn.returnOrder">
                                <span>{{
                                  detailsorderReturn.returnOrder.returnNumber
                                }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column
                              header-align="center"
                              align="center"
                              prop="returnAmount"
                              label="申请退款金额"
                            >
                              <template v-if="detailsorderReturn.returnOrder">
                                <span>{{
                                  detailsorderReturn.returnOrder.returnAmount
                                }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column
                              header-align="center"
                              align="center"
                              width="200"
                              prop="actuallyPrice"
                              label="确认退款金额"
                            >
                              <template v-if="detailsorderReturn.returnOrder">
                                <el-input
                                  clearable
                                  type="number"
                                  @mousewheel.prevent.native
                                  :disabled="disabled || show"
                                  style="width:150px;"
                                  v-model.trim="
                                    detailsorderReturn.returnOrder.confirmReturnAmount
                                  "
                                  placeholder="请输入确认退款金额"
                                  size="small"
                                ></el-input>
                              </template>
                            </el-table-column>
                          </el-table>
                        </div>
                        <div class="mb20">
                          <el-table
                            stripe
                            border
                            :data="[detailsorderReturn.orderInfo]"
                            size="small"
                          >
                            <el-table-column
                              header-align="center"
                              align="center"
                              prop="receiverName"
                              label="退货申请人"
                            >
                            </el-table-column>
                            <el-table-column
                              header-align="center"
                              align="center"
                              prop="memberMobile"
                              label="电话"
                            ></el-table-column>
                            <el-table-column
                              header-align="center"
                              align="center"
                              prop="returnReason"
                              label="退货原因"
                            >
                              <template v-if="detailsorderReturn.returnOrder">
                                <span>{{
                                  detailsorderReturn.returnOrder.returnReason
                                }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column
                              header-align="center"
                              align="center"
                              prop="returnSendTime"
                              label="申请时间"
                            >
                              <span v-if="detailsorderReturn.returnOrder">
                                {{ detailsorderReturn.returnOrder.returnSendTime }}
                              </span>
                            </el-table-column>
                          </el-table>
                        </div>
                      </li>
                      <li class="mb20">
                        <el-table
                          border
                          :data="detailsorderReturn.goodsList"
                          size="small"
                          :row-class-name="tableRowClassName"
                        >
                          <el-table-column
                            header-align="center"
                            align="center"
                            prop="goodsImg"
                            label="商品图片"
                          >
                            <template slot-scope="scope">
                              <div>
                                <img
                                  class="warning-tuikuan"
                                  v-show="scope.row.returnType === 'yes'"
                                  src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                                  alt=""
                                />
                                <img
                                  class="warning-tuikuan"
                                  v-show="scope.row.returnType === 'doing'"
                                  src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                                  alt=""
                                />

                                <img
                                  style="width:100px;height:100px;"
                                  v-if="scope.row.goodsImg"
                                  :src="scope.row.goodsImg"
                                  alt=""
                                />
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column
                            header-align="center"
                            align="center"
                            prop="spuName"
                            label="商品名称/品牌"
                          >
                            <template slot-scope="scope">
                              <p>{{ scope.row.spuName }}</p>
                              <p>品牌: {{ scope.row.brandName }}</p>
                            </template>
                          </el-table-column>
                          <el-table-column
                            header-align="center"
                            align="center"
                            prop="spuName"
                            label="价格/货号"
                          >
                            <template slot-scope="scope">
                              <p>价格: {{ scope.row.totalPrice }}</p>
                              <p v-if="scope.row.goodsSn">货号: {{ scope.row.goodsSn }}</p>
                            </template>
                          </el-table-column>
                          <el-table-column
                            header-align="center"
                            align="center"
                            prop="spuName"
                            label="净重/毛重"
                          >
                            <template slot-scope="scope">
                              <p v-if="scope.row.netWeight">
                                净重: {{ scope.row.netWeight }}
                              </p>
                              <p v-if="scope.row.grossWeight">
                                毛重: {{ scope.row.grossWeight }}
                              </p>
                            </template>
                          </el-table-column>
                          <el-table-column
                            header-align="center"
                            align="center"
                            prop=""
                            label="规格"
                          >
                            ---
                          </el-table-column>
                          <el-table-column
                            header-align="center"
                            align="center"
                            prop="goodsNum"
                            label="数量"
                          ></el-table-column>
                          <el-table-column
                            header-align="center"
                            align="center"
                            prop="totalPrice"
                            label="小计"
                          >
                            <template slot-scope="scope">
                              <p>￥{{ scope.row.totalPrice * scope.row.goodsNum }}</p>
                            </template>
                          </el-table-column>
                        </el-table>
                      </li>
                      <li class="mb20">
                        <div class="title">收货人信息</div>
                        <el-table
                          stripe
                          border
                          :data="[detailsorderReturn.orderInfo]"
                          size="small"
                        >
                          <el-table-column
                            header-align="center"
                            align="center"
                            prop="receiverName"
                            label="收货人"
                          >
                          </el-table-column>
                          <el-table-column
                            header-align="center"
                            align="center"
                            prop="receiverMobile"
                            label="手机号码"
                          >
                          </el-table-column>

                          <el-table-column
                            header-align="center"
                            align="center"
                            prop="spuName"
                            label="收货地址"
                          >
                            <template
                              slot-scope="scope"
                              v-if="detailsorderReturn.orderInfo"
                            >
                              <span>
                                {{ scope.row.deliveryProvince
                                }}{{ scope.row.deliveryAddress }}
                              </span>
                            </template>
                          </el-table-column>
                        </el-table>
                      </li>
                      <li class="mb20">
                        <div class="title">操作信息</div>
                        <el-table
                          stripe
                          border
                          :data="detailsorderReturn.status"
                          size="small"
                        >
                          <el-table-column
                            header-align="center"
                            align="center"
                            prop="operator"
                            label="操作者"
                          ></el-table-column>
                          <el-table-column
                            header-align="center"
                            align="center"
                            prop="val"
                            label="操作"
                          >
                          </el-table-column>
                          <el-table-column
                            header-align="center"
                            align="center"
                            prop="time"
                            label="操作时间"
                          ></el-table-column>
                        </el-table>
                      </li>
                    </ul> -->
                    <ul class="info-list flex-1" style="width:50%">
                        <div style="paddingLeft:10px">
                            <li class="mb20">
                                <div class="title">基本信息</div>
                                <div class="mb20">
                                    <el-table
                                            stripe
                                            border
                                            :data="[detailsOrder.order]"
                                            size="small"
                                    >
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="receiptSn"
                                                label="订单号"
                                        ></el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="spuName"
                                                label="发货单流水号"
                                        ></el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="memberMobile"
                                                label="会员手机号"
                                        ></el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="payMode"
                                                label="支付方式"
                                        >
                                            <template slot-scope="scope">
                        <span
                                class="status danger"
                                v-if="scope.row.payMode === 'no_pay'"
                        >未支付</span
                        >
                                                <span
                                                        class="status danger"
                                                        v-if="scope.row.payMode === '0_pay'"
                                                >0元订单</span
                                                >
                                                <span
                                                        class="status danger"
                                                        v-if="scope.row.payMode === 'wx_pay'"
                                                >微信支付</span
                                                >
                                                <span
                                                        class="status danger"
                                                        v-if="scope.row.payMode === 'ali_pay'"
                                                >支付支付</span
                                                >
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="orderSource"
                                                label="订单来源"
                                        >
                                            <template slot-scope="scope">
                        <span v-if="scope.row.orderSource === 'wxShop'"
                        >微店订单</span
                        >
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="orderType"
                                                label="订单类型"
                                        >
                                            <template slot-scope="scope">
                        <span v-if="scope.row.orderType === 'wshop'"
                        >微店订单</span
                        >
                                                <span v-if="scope.row.orderType === 'ptdd'"
                                                >拼团订单</span
                                                >
                                                <span v-if="scope.row.orderType === 'kjdd'"
                                                >砍价订单</span
                                                >
                                                <span v-if="scope.row.orderType === 'mshd'"
                                                >秒杀订单</span
                                                >
                                                <span v-if="scope.row.orderType === 'smg_faceToFace'"
                                                >代客下单-当面收款</span
                                                >
                                                <span v-if="scope.row.orderType === 'smg_netPush'"
                                                >代客下单-网络推送</span
                                                >
                                                <span v-if="scope.row.orderType === 'dhdd'"
                                                >兑换订单</span
                                                >
                                                <span v-if="scope.row.orderType === 'integral_order'"
                                                >积分兑换订单</span
                                                >
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div class="mb20">
                                    <el-table
                                            stripe
                                            border
                                            :data="[detailsOrder.order]"
                                            size="small"
                                    >
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="deliveryType"
                                                label="配送方式"
                                        >
                                            <template slot-scope="scope">
                        <span v-if="scope.row.deliveryType === 'mdzt'"
                        >门店自提</span
                        >
                                                <span v-if="scope.row.deliveryType === 'kdfh'"
                                                >快递发货</span
                                                >
                                                <span v-if="scope.row.deliveryType === 'tcps'"
                                                >同城配送</span
                                                >
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                v-if="detailsOrder.order.deliveryType === 'mdzt'"
                                                header-align="center"
                                                align="center"
                                                prop="billNo"
                                                label="提货单号"
                                        ></el-table-column>
                                        <el-table-column
                                                v-else
                                                header-align="center"
                                                align="center"
                                                prop="expressOrderSn"
                                                label="物流单号"
                                        ></el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="spuName"
                                                label="自动确认收货时间"
                                        ></el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="shopName"
                                                label="指定信息"
                                        ></el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="orderRemark"
                                                label="订单备注"
                                        ></el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="spuName"
                                                label="活动信息"
                                        ></el-table-column>
                                    </el-table>
                                </div>
                            </li>
                            <li class="mb20">
                                <div class="title">收货人信息</div>
                                <el-table
                                        stripe
                                        border
                                        :data="[detailsOrder.order]"
                                        size="small"
                                >
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="receiverName"
                                            label="收货人"
                                    ></el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="receiverMobile"
                                            label="手机号码"
                                    ></el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="spuName"
                                            label="邮政编码"
                                    ></el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="deliveryAddress"
                                            label="收货地址"
                                    >
                                        <template slot-scope="scope">
                      <span
                      >{{ scope.row.deliveryProvince
                        }}{{ scope.row.deliveryAddress }}</span
                      >
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </li>
                            <li class="mb20">
                                <div class="title">商品信息</div>
                                <el-table
                                        border
                                        :data="detailsOrder.orderGoods"
                                        size="small"
                                        :row-class-name="tableRowClassNames"
                                >
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="goodsImg"
                                            label="商品图片"
                                            width="150"
                                    >
                                        <template slot-scope="scope">
                                            <div>
                                                <div
                                                        class="flex flex-center item-center"
                                                        v-if="scope.row.returnType !== 'no'"
                                                >
                                                    <!-- 仅退款 -->
                                                    <img
                                                            v-if="scope.row.refundReturnType === 'money'"
                                                            style="width:100px;height:100px"
                                                            src="https://imgcdn.hemiao100.com/hemiaoBase/81d2994f64c85809bf951f14fd56ecc.png"
                                                            alt=""
                                                    />

                                                    <!-- 退货退款 -->
                                                    <img
                                                            v-if="scope.row.refundReturnType === 'refund'"
                                                            style="width:100px;height:100px"
                                                            src="https://imgcdn.hemiao100.com/hemiaoBase/8088827e177ba800a9eba2c17e295c8.png"
                                                            alt=""
                                                    />

                                                    <!-- 退运费 -->
                                                    <img
                                                            v-if="scope.row.refundReturnType === 'deliver'"
                                                            style="width:100px;height:100px"
                                                            src="https://imgcdn.hemiao100.com/hemiaoBase/9a0ad12b4cead9d04371c126a61d5d5.png"
                                                            alt=""
                                                    />
                                                </div>

                                                <img
                                                        class="warning-tuikuan"
                                                        v-show="scope.row.returnType === 'yes'"
                                                        src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                                                        alt=""
                                                />
                                                <img
                                                        class="warning-tuikuan"
                                                        v-show="scope.row.returnType === 'doing'"
                                                        src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                                                        alt=""
                                                />
                                                <div
                                                        class="flex flex-center item-center"
                                                        :class="
                            scope.row.returnType !== 'no' ? 'only-tuikuan' : ''
                          "
                                                >
                                                    <img
                                                            style="width:100px;height:100px;"
                                                            v-if="scope.row.goodsImg"
                                                            :src="scope.row.goodsImg"
                                                            alt=""
                                                    />
                                                </div>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="spuName"
                                            label="商品名称/品牌"
                                    >
                                        <template slot-scope="scope">
                                            <el-tooltip
                                                    class="item"
                                                    :content="scope.row.spuName"
                                                    placement="top"
                                            >
                                                <div class="flex item-center">
                                                    <!-- <span class="pos" v-if="scope.row.createMode">
                                                    p
                                                  </span> -->

                                                    <span class="time flex-1 text-overflow">
                            {{ scope.row.spuName }}
                          </span>
                                                </div>
                                            </el-tooltip>
                                            <div>品牌: {{ scope.row.brandName }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="spuName"
                                            label="价格/货号"
                                    >
                                        <template slot-scope="scope">
                                            <p>价格: {{ scope.row.totalPrice }}</p>
                                            <p>货号: {{ scope.row.goodsSn }}</p>
                                            <p>条码: {{ scope.row.barCode }}</p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="spuName"
                                            label="净重/毛重"
                                    >
                                        <template slot-scope="scope">
                                            <p v-if="scope.row.netWeight">
                                                净重: {{ scope.row.netWeight }}
                                            </p>
                                            <p v-if="scope.row.grossWeight">
                                                毛重: {{ scope.row.grossWeight }}
                                            </p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="specIdGroupName"
                                            label="规格"
                                    ></el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="goodsNum"
                                            label="数量"
                                    ></el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="totalPrice"
                                            label="小计"
                                    >
                                        <template slot-scope="scope">
                                            <p>
                                                {{
                                                (scope.row.totalPrice * scope.row.goodsNum).toFixed(2)
                                                }}
                                            </p>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </li>
                            <li class="mb20">
                                <div class="title">费用信息</div>
                                <el-table
                                        stripe
                                        border
                                        :data="[detailsOrder.order]"
                                        size="small"
                                >
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="totalPrice"
                                            label="商品合计"
                                    >
                                        <template slot-scope="scope">
                                            <p>￥{{ scope.row.totalPrice }}</p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="deliverMoney"
                                            label="运费"
                                    >
                                        <template slot-scope="scope">
                                            <p>￥{{ scope.row.deliverMoney }}</p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="deliverCouponMoney"
                                            label="运费券抵扣"
                                    >
                                        <template slot-scope="scope">
                      <span class="status danger"
                      >-￥{{ scope.row.deliverCouponMoney }}</span
                      >
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="couponMoney"
                                            label="优惠券"
                                    >
                                        <template slot-scope="scope">
                      <span class="status danger"
                      >-￥{{ scope.row.couponMoney }}</span
                      >
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="activeMoney"
                                            label="积分抵扣"
                                            v-if="detailsOrder.order.orderType === 'integral_order'"
                                    >
                                        <template slot-scope="scope">
                      <span class="status danger"
                      >-￥{{ scope.row.activeMoney }}</span
                      >
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="activeMoney"
                                            label="活动优惠"
                                            v-else
                                    >
                                        <template slot-scope="scope">
                      <span class="status danger"
                      >-￥{{ scope.row.activeMoney }}</span
                      >
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="activeMoney"
                                            label="金豆"
                                            v-if="
                      detailsOrder.order.otherPayInfo &&
                        detailsOrder.order.otherPayInfo.length
                    "
                                    >
                                        <template slot-scope="scope">
                                            <div v-for="(v, i) in scope.row.otherPayInfo" :key="i">
                                                <div v-if="v.financeCode === 'goldBean'">
                                                    金豆：已用{{ v.financeValue }}{{ v.relName }}抵用
                                                    <span class="danger">-￥{{ v.currencyAmount }}</span>
                                                </div>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="actuallyPrice"
                                            label="实付金额"
                                    >
                                        <template slot-scope="scope">
                                            <div
                                                    v-if="scope.row.orderType === 'integral_order'"
                                                    class="status danger"
                                            >
                        <span v-if="scope.row.actuallyPrice"
                        >¥{{ scope.row.actuallyPrice }}+</span
                        >
                                                <span>{{ scope.row.integralPoint }}积分 </span>
                                            </div>
                                            <span v-else class="status danger"
                                            >¥{{ scope.row.actuallyPrice }}</span
                                            >
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="payPrice"
                                            label="应付金额"
                                    >
                                        <template slot-scope="scope">
                                            <div
                                                    v-if="scope.row.orderType === 'integral_order'"
                                                    class="status danger"
                                            >
                        <span v-if="scope.row.payPrice"
                        >¥{{ scope.row.payPrice }}+</span
                        >
                                                <span>{{ scope.row.integralPoint }}积分 </span>
                                            </div>
                                            <span v-else class="status danger"
                                            >¥{{ scope.row.payPrice }}</span
                                            >
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </li>
                            <li class="mb20">
                                <div class="title">操作信息</div>
                                <el-table
                                        stripe
                                        border
                                        :data="detailsOrder.orderStatus"
                                        size="small"
                                >
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="operatorAccount"
                                            label="操作账号"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="operatorName"
                                            label="操作人"
                                    >
                                        <template slot-scope="scope">
                                            <div v-if="scope.row.operatorName === null">
                                                {{ scope.row.createBy }}
                                            </div>
                                            <div v-else>
                                                {{ scope.row.operatorName }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="createTime"
                                            label="操作时间"
                                    ></el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="spuName"
                                            label="订单状态"
                                    >
                                        <template slot-scope="scope">
                      <span
                              class="status blue"
                              v-if="scope.row.orderStatus === 'createOrder'"
                      >待付款</span
                      >
                                            <span
                                                    class="status blue"
                                                    v-if="scope.row.orderStatus === 'payOrder'"
                                            >待发货</span
                                            >
                                            <span
                                                    class="status blue"
                                                    v-if="scope.row.orderStatus === 'deliverOrder'"
                                            >已发货</span
                                            >
                                            <span
                                                    class="status blue"
                                                    v-if="scope.row.orderStatus === 'takeOrder'"
                                            >已收货</span
                                            >
                                            <span
                                                    class="status blue"
                                                    v-if="scope.row.orderStatus === 'pushOrder'"
                                            >已评价</span
                                            >
                                            <span
                                                    class="status blue"
                                                    v-if="scope.row.orderStatus === 'delOrder'"
                                            >已取消</span
                                            >
                                            <span
                                                    class="status blue"
                                                    v-if="scope.row.orderStatus === 'returnOrder'"
                                            >有退货退款</span
                                            >
                                            <span
                                                    class="status blue"
                                                    v-if="scope.row.orderStatus === 'rejectOrder'"
                                            >驳回申请</span
                                            >
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="spuName"
                                            label="付款状态"
                                    >
                                        <template slot-scope="scope">
                      <span
                              class="status blue"
                              v-if="scope.row.orderStatus === 'createOrder'"
                      >未付款</span
                      >
                                            <span
                                                    class="status blue"
                                                    v-if="scope.row.orderStatus === 'payOrder'"
                                            >已付款</span
                                            >
                                            <span
                                                    class="status blue"
                                                    v-if="scope.row.orderStatus === 'deliverOrder'"
                                            >已付款</span
                                            >
                                            <span
                                                    class="status blue"
                                                    v-if="scope.row.orderStatus === 'takeOrder'"
                                            >已付款</span
                                            >
                                            <span
                                                    class="status blue"
                                                    v-if="scope.row.orderStatus === 'pushOrder'"
                                            >已付款</span
                                            >
                                            <span
                                                    class="status blue"
                                                    v-if="scope.row.orderStatus === 'delOrder'"
                                            >已取消</span
                                            >
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="spuName"
                                            label="发货状态"
                                    >
                                        <template slot-scope="scope">
                      <span
                              class="status blue"
                              v-if="scope.row.orderStatus === 'createOrder'"
                      >未发货</span
                      >
                                            <span
                                                    class="status blue"
                                                    v-if="scope.row.orderStatus === 'payOrder'"
                                            >未发货</span
                                            >
                                            <span
                                                    class="status blue"
                                                    v-if="scope.row.orderStatus === 'deliverOrder'"
                                            >已发货</span
                                            >
                                            <span
                                                    class="status blue"
                                                    v-if="scope.row.orderStatus === 'takeOrder'"
                                            >已发货</span
                                            >
                                            <span
                                                    class="status blue"
                                                    v-if="scope.row.orderStatus === 'pushOrder'"
                                            >已发货</span
                                            >
                                            <span
                                                    class="status blue"
                                                    v-if="scope.row.orderStatus === 'delOrder'"
                                            >已取消</span
                                            >
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            header-align="center"
                                            align="center"
                                            prop="remark"
                                            label="备注"
                                    ></el-table-column>
                                    <!-- <el-table-column
                                    header-align="center"
                                    align="center"
                                    label="操作"
                                  >
                                    <template slot-scope="scope">
                                      <div class="flex flex-center">
                                        <el-button size="small" type="text" @click="beizhu(scope.row)"
                                          >添加备注</el-button
                                        >
                                      </div>
                                    </template>
                                  </el-table-column> -->
                                </el-table>
                            </li>
                        </div>
                    </ul>
                    <ul class="info-list flex-1" style="width:50%">
                        <div style="padding:0 10px">
                            <li>
                                <div class="progress mb20" v-if="delOrder">
                                    <el-steps :active="active" align-center>
                                        <el-step
                                                title="发起申请"
                                                :description="returnSendTime"
                                        ></el-step>
                                        <el-step
                                                title="核定信息"
                                                :description="returnConfirmTime"
                                        ></el-step>
                                        <el-step
                                                v-if="returnInfo.status !== 8"
                                                title="退货/退款"
                                                :description="refundTime"
                                        ></el-step>
                                        <el-step
                                                title="驳回"
                                                v-if="returnInfo.status == 8"
                                        ></el-step>
                                    </el-steps>
                                    <!-- <el-steps :active="active" align-center>
                                    <el-step title="创建订单" :description="createOrderTime"></el-step>
                                    <el-step title="支付订单" :description="payOrderTime"></el-step>
                                    <el-step
                                      title="平台配货发货"
                                      :description="deliverOrderTime"
                                    ></el-step>
                                    <el-step title="确认收货" :description="takeOrderTime"></el-step>
                                    <el-step title="完成评价" :description="pushOrderTime"></el-step>
                                  </el-steps> -->
                                </div>
                            </li>
                            <li class="mb20">
                                <div class="title">退款单</div>
                                <div class="mb20 flex-1">
                                    <el-table
                                            border
                                            :data="returnGoods"
                                            :span-method="objectSpanMethod"
                                            size="small"
                                            @row-click="openDetails"
                                            highlight-current-row
                                            :row-class-name="tableRowClassName"
                                    >
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="returnSn"
                                                label="退货单号"
                                        ></el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="spuName"
                                                label="商品名称"
                                        >
                                            <template slot-scope="scope">
                                                <el-tooltip
                                                        class="item"
                                                        :content="scope.row.spuName"
                                                        placement="top"
                                                >
                                                    <div class="flex item-center">
                                                        <!-- <span class="pos" v-if="scope.row.createMode">
                                                        p
                                                      </span> -->
                                                        <span class="time flex-1 text-overflow">
                              {{ scope.row.spuName }}
                            </span>
                                                    </div>
                                                </el-tooltip>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="returnSendTime"
                                                label="退单时间"
                                        ></el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="status"
                                                label="退款状态"
                                        >
                                            <template slot-scope="scope">
                        <span class="danger" v-if="scope.row.status === 1"
                        >待审核</span
                        >
                                                <span class="danger" v-if="scope.row.status === 2"
                                                >已审核</span
                                                >
                                                <span class="danger" v-if="scope.row.status === 3"
                                                >已退货待退款</span
                                                >
                                                <span class="blue" v-if="scope.row.status === 4"
                                                >已退款</span
                                                >
                                                <span class="gray" v-if="scope.row.status === 5"
                                                >待确认</span
                                                >
                                                <span class="danger" v-if="scope.row.status === 8"
                                                >已驳回</span
                                                >
                                                <span class="gray" v-if="scope.row.status === 9"
                                                >已取消</span
                                                >
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="returnAmount"
                                                label="退商品"
                                        >
                                            <template slot-scope="scope">
                        <span class="danger"
                        >¥{{ scope.row.returnAmount }}</span
                        >
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="confirmReturnAmount"
                                                label="商品核定"
                                                width="100"
                                        >
                                            <template slot-scope="scope">
                                                <el-input
                                                        v-if="scope.row.status === 1"
                                                        clearable
                                                        type="txt"
                                                        @mousewheel.prevent.native
                                                        @input="
                            filterGt0OrFixed2(
                              'confirmReturnAmount',
                              scope.$index
                            )
                          "
                                                        style="width:100%;"
                                                        v-model.trim="scope.row.confirmReturnAmount"
                                                        size="small"
                                                ></el-input>
                                                <div v-else>
                          <span class="danger"
                          >¥{{ scope.row.confirmReturnAmount }}</span
                          >
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="returnDeliverMoney"
                                                label="退运费"
                                        >
                                            <template slot-scope="scope">
                        <span class="danger"
                        >¥{{ scope.row.returnDeliverMoney }}</span
                        >
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="confirmReturnDeliverMoney"
                                                label="运费核定"
                                                width="100"
                                        >
                                            <template slot-scope="scope">
                                                <el-input
                                                        v-if="scope.row.status === 1"
                                                        clearable
                                                        type="txt"
                                                        @mousewheel.prevent.native
                                                        @input="
                            filterGt0OrFixed2(
                              'confirmReturnDeliverMoney',
                              scope.$index
                            )
                          "
                                                        style="width:100%;"
                                                        v-model.trim="scope.row.confirmReturnDeliverMoney"
                                                        size="small"
                                                ></el-input>
                                                <div v-else>
                          <span class="danger"
                          >¥{{ scope.row.confirmReturnDeliverMoney }}</span
                          >
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="prepayMoney"
                                                label="退储值卡"
                                                v-if="!queryConfigFlag"
                                        >
                                            <template slot-scope="scope">
                                                <span class="danger">¥{{ scope.row.prepayMoney }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="returnPrepayCardMoney"
                                                label="退储值卡"
                                                v-if="queryConfigFlag"
                                        >
                                            <template slot-scope="scope">
                        <span class="danger"
                        >¥{{ scope.row.returnPrepayCardMoney }}</span
                        >
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="confirmReturnPrepayCardMoney"
                                                label="核定退储值卡"
                                                width="100"
                                        >
                                            <template slot-scope="scope">
                                                <el-input
                                                        v-if="scope.row.status === 1"
                                                        clearable
                                                        type="txt"
                                                        @mousewheel.prevent.native
                                                        @input="
                            filterGt0OrFixed2(
                              'confirmReturnPrepayCardMoney',
                              scope.$index
                            )
                          "
                                                        style="width:100%;"
                                                        v-model.trim="scope.row.confirmReturnPrepayCardMoney"
                                                        size="small"
                                                ></el-input>
                                                <div v-else>
                          <span class="danger"
                          >¥{{ scope.row.confirmReturnPrepayCardMoney }}</span
                          >
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="returnIntegral"
                                                label="退积分"
                                                v-if="isShowReturnIntegral"
                                        >
                                            <template slot-scope="scope">
                        <span class="danger">{{
                          scope.row.returnIntegral
                        }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                label="核定退积分"
                                                v-if="isShowReturnIntegral"
                                                width="100"
                                        >
                                            <template slot-scope="scope">
                                                <div v-if="active < 2">
                                                    <el-input
                                                            v-if="scope.row.confirmReturnIntegral"
                                                            clearable
                                                            type="txt"
                                                            @mousewheel.prevent.native
                                                            @input="
                              filterGt0OrFixed2(
                                'confirmReturnIntegral',
                                scope.$index
                              )
                            "
                                                            style="width:100%;"
                                                            v-model.trim="scope.row.confirmReturnIntegral"
                                                            size="small"
                                                    ></el-input>
                                                    <div v-else>
                            <span class="danger"
                            >¥{{ scope.row.confirmReturnIntegral }}</span
                            >
                                                    </div>
                                                </div>
                                                <div v-else class="danger">
                                                    {{ scope.row.confirmReturnIntegral }}
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                label="操作"
                                                header-align="center"
                                                align="center"
                                                width="130"
                                        >
                                            <template slot-scope="scope">
                                                <div
                                                        class="flex flex-center"
                                                        v-if="scope.row.status === 1 && isBtn('tongyi:false')"
                                                >
                                                    <el-button
                                                            size="small"
                                                            type="text"
                                                            @click="consent(scope.$index)"
                                                    >同意退款</el-button
                                                    >
                                                    <el-button
                                                            size="small"
                                                            type="text"
                                                            v-if="refundAgain !== 'yes'"
                                                            @click="bohui(scope.$index)"
                                                    >驳回</el-button
                                                    >
                                                </div>
                                                <div
                                                        class="flex flex-center"
                                                        v-if="scope.row.status === 2 && isBtn('queren:false')"
                                                >
                                                    <el-button
                                                            size="small"
                                                            type="text"
                                                            @click="consent(scope.$index)"
                                                    >确认退款</el-button
                                                    >
                                                    <el-button
                                                            size="small"
                                                            type="text"
                                                            @click="bohui(scope.$index)"
                                                    >驳回</el-button
                                                    >
                                                </div>
                                                <div
                                                        class="flex flex-center"
                                                        v-if="scope.row.status === 4"
                                                >
                                                    <el-button
                                                            size="small"
                                                            type="text"
                                                            @click="jixu(scope.$index)"
                                                    >继续退款</el-button
                                                    >
                                                </div>
                                                <div v-if="scope.row.status === 5">
                                                    <el-button
                                                            size="small"
                                                            type="text"
                                                            @click="undo(scope.row)"
                                                    >撤销</el-button
                                                    >
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div class="mb20">
                                    <div class="title">操作记录</div>
                                    <el-table stripe border :data="refundRecordList" size="small">
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="receiverName"
                                                label="操作状态"
                                        >
                                            <template slot-scope="scope">
                        <span v-if="scope.row.operationType === 'apply'"
                        >申请退款</span
                        >
                                                <span v-else-if="scope.row.operationType === 'agree'"
                                                >同意退款</span
                                                >
                                                <span v-else-if="scope.row.operationType === 'refuse'"
                                                >驳回申请</span
                                                >
                                                <span v-else-if="scope.row.operationType === 'pay'"
                                                >确认退款</span
                                                >
                                                <span
                                                        v-else-if="scope.row.operationType === 'backApply'"
                                                >后台发起</span
                                                >
                                                <span
                                                        v-else-if="scope.row.operationType === 'agreeAgain'"
                                                >再次同意</span
                                                >
                                                <span v-else-if="scope.row.operationType === 'payAgain'"
                                                >再次确认</span
                                                >
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="returnAmount"
                                                label="金额/积分"
                                        >
                                            <template slot-scope="scope">
                        <span class="danger"
                        >¥{{ scope.row.returnAmount }} /
                          {{ scope.row.returnIntegral || 0 }}积分</span
                        >
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="returnDeliverMoney"
                                                label="运费"
                                        >
                                            <template slot-scope="scope">
                        <span class="danger"
                        >¥{{ scope.row.returnDeliverMoney }}
                        </span>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="operationRemark"
                                                label="操作备注"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="operationTime"
                                                label="操作时间"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                                header-align="center"
                                                align="center"
                                                prop="operationName"
                                                label="操作人"
                                        >
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </li>
                        </div>
                    </ul>
                </div>
            </div>
            <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="close" size="small" type="primary">关闭</el-button>
      </span>
            <!-- <span
              slot="footer"
              class="dialog-footer flex flex-center"
              v-if="!disabled"
            >
              <el-button
                @click="consent"
                size="small"
                type="primary"
                v-if="returnType === 'money' && status == 1"
              >
                同意退款</el-button
              >
              <el-button
                @click="consent"
                size="small"
                type="primary"
                v-if="returnType === 'money' && status == 2"
              >
                确认退款</el-button
              >
              <el-button
                @click="consent"
                size="small"
                type="primary"
                v-if="returnType === 'refund' && status == 1"
              >
                同意退货</el-button
              >
              <el-button
                @click="consent"
                size="small"
                type="primary"
                v-if="returnType === 'refund' && status == 2"
              >
                确认退货</el-button
              >
              <el-button
                @click="consent"
                size="small"
                type="primary"
                v-if="returnType === 'refund' && status == 3"
              >
                确认退款</el-button
              >

              <el-button @click="reject" size="small" type="primary">驳回</el-button>
            </span> -->
        </el-dialog>
        <el-dialog
                title="操作备注"
                :visible.sync="detailsVisible"
                @close="detailsVisible = false"
                custom-class="sales-volumn-dialog"
        >
            <el-form
                    label-width="80px"
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
            >
                <el-form-item label="操作备注" prop="operationRemark">
                    <el-input
                            maxlength="100"
                            placeholder="请输入操作备注"
                            size="small"
                            style="width: auto"
                            ref="textarea"
                            :autosize="{ minRows: 4 }"
                            type="textarea"
                            v-model="ruleForm.operationRemark"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
                id="btn"
                @click="reject('ruleForm')"
                size="small"
                type="primary"
        >确认</el-button
        >
        <el-button @click="detailsVisible = false" size="small">关闭</el-button>
      </span>
        </el-dialog>

        <!-- 储值卡已被使用过提示 -->
        <el-dialog
                :visible.sync="prepayCardUsedVisible"
                @close="prepayCardUsedVisible = false"
                custom-class="sales-volumn-dialog"
                width="1200px"
        >
      <span slot="title">
        <div class="orange" style="font-size:18px;font-weight:bold">
          {{ prepayCardUsedErrmag }}
        </div>
      </span>
            <el-table stripe border :data="memberRelModelList" size="small">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="cardName"
                        label="储值卡名称"
                >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="memberName"
                        label="持卡人姓名"
                >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="cardNo"
                        label="持卡人卡号"
                >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="memberMobile"
                        label="持卡人电话"
                >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="cardStatus"
                        label="卡状态"
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.level === 1">--</div>
                        <div v-else>
                            <div v-if="scope.row.cardStatus === 'frozen'" class="danger">
                                冻结
                            </div>
                            <div v-if="scope.row.cardStatus === 'lock'" class="blue">
                                锁定
                            </div>
                            <div v-if="scope.row.cardStatus === 'ok'" class="success">
                                正常
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="sourceType"
                        label="获得方式"
                >
                    <template slot-scope="scope">
                        {{ scope.row.sourceType === "buy" ? "购买" : "赠送" }}
                        <div v-if="scope.row.sourceType === 'give'">
                            <el-button type="text" size="small" @click="giveInfo(scope.row)">
                                赠送来源
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="sourceReceiptSn"
                        label="购卡订单号"
                >
                    <template slot-scope="scope">
                        {{ scope.row.sourceReceiptSn }}
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="cardSalePrice"
                        label="储值卡售价"
                >
                    <template slot-scope="scope">
                        <div class="primary">{{ scope.row.cardSalePrice }}元</div>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="cardDenomination"
                        label="储值卡面额"
                >
                    <template slot-scope="scope">
                        <div class="primary">{{ scope.row.cardDenomination }}元</div>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="cardBalance"
                        label="储值卡余额"
                >
                    <template slot-scope="scope">
                        <div class="primary">{{ scope.row.cardBalance }}元</div>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="cardStartTime"
                        label="购买时间"
                >
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="cardsTime"
                        label="储值卡有效期"
                        width="150"
                >
                    <template slot-scope="scope">
                        {{ scope.row.cardStartTime }}至{{ scope.row.cardEndTime }}
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer flex flex-center">
        <el-button id="btn" size="small" type="primary" @click="doubleReject"
        >确认退款</el-button
        >
        <el-button @click="prepayCardUsedVisible = false" size="small"
        >关闭</el-button
        >
      </span>
        </el-dialog>
    </hm-content>
</template>

<script>
    import { mapGetters } from "vuex";
    import { outPutMixin } from "@/mixins/outputMixin";
    import { setCookie, getCookie, formatFloat } from "@/utils/utils";
    import moment from "moment";
    export default {
        mixins: [outPutMixin],
        data() {
            return {
                total:0,
                waitStatus:[],
                prepayCardUsedErrmag: "",
                memberRelModelList: [],
                prepayCardUsedVisible: false,
                ruleForm: {
                    operationRemark: ""
                },
                rules: {
                    // operationRemark: {
                    //   required: true,
                    //   message: "请输入操作备注",
                    //   trigger: "change"
                    // }
                },
                detailsVisible: false,
                dialogVisible: false,
                logisticsInfoVisible: false,
                disabled: false,
                show: false,
                checkedRow: {},
                batchCondition: {},
                searchCondition: {
                    storeCode:'',
                    queryTimeType: "returnSendTime",
                    status: "1",
                    applyDate: [
                        moment().format("YYYY-MM-DD") + " 00:00:00",
                        moment().format("YYYY-MM-DD") + " 23:59:59"
                    ]
                },
                currentPage: 1,
                pageSize: 10,
                active: 1,
                title: "",
                returnSendTime: "",
                refundTime: "",
                returnConfirmTime: "",
                delOrder: true,
                innerVisible: false,
                isOutputing: false,
                orderGoodsId: "",
                totalPrice: "",
                orderRefundId: "",
                status: "",
                returnType: "",
                receiptSn: "",
                orderSta: "",
                createOrderTime: "",
                payOrderTime: "",
                deliverOrderTime: "",
                takeOrderTime: "",
                pushOrderTime: "",
                returnGoods: [],
                returnSn: "",
                refundRecordList: [],
                confirmReturnAmount: "",
                confirmReturnDeliverMoney: "",
                confirmReturnPrepayCardMoney: "",
                returnInfo: {},
                orderId: "",
                queryConfigFlag: false,
                position: 0,
                rowSpanArr: [],
                isShowReturnIntegral: false,
                returnIntegral: 0,
                confirmReturnIntegral: 0,
                refundAgain: "",
                tableData:[],
                distributor:[]
            };
        },
        created() {
            this.query_share_store_list();
            this.getParamsCookie();
            this.$store.dispatch("queryMicroStoreList");
            if (this.$route.query.type) {
                this.searchCondition.status = this.$route.query.type;
            }
            this.queryList();
            this.queryConfigRefundAmount();
        },
        computed: mapGetters([
            "orderReturnList",
            "detailsorderReturn",
            "salesChannels",
            "allMallGoodsList",
            "shopModelList",
            "microShopStoreList",
            "detailsOrder"
        ]),
        watch: {
            activityCategoryList(val) {
                this.activityChildCategoryList = [];
                val.forEach(v => {
                    this.activityChildCategoryList = this.activityChildCategoryList.concat(
                        v.nodes
                    );
                });
            }
        },
        methods: {
            async query_share_store_list(){   //查询分销商
                const { result } = await this.$store.dispatch("share_store_list");
                console.log(result);
                this.distributor = result;

            },
            // getSummaries(param) {
            //   const { columns, data } = param;
            //   const sums = [];
            //   columns.forEach((column, index) => {
            //     if (index === 0) {
            //       sums[index] = "合计";
            //       return;
            //     }
            //     const values = data.map(item => Number(item[column.property]));
            //     if (!values.every(value => isNaN(value))) {
            //       sums[index] = values.reduce((prev, curr) => {
            //         const value = Number(curr);
            //         if (!isNaN(value)) {
            //           return prev + curr;
            //         } else {
            //           return prev;
            //         }
            //       }, 0);
            //       sums[index] += " 元";
            //     } else {
            //       sums[index] = "";
            //     }
            //   });

            //   return sums;
            // },
            async removes() {
                const confirm = await this.$confirm(" 删除本行数据?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                });
                if (confirm === "confirm") {
                    console.log("a: ", 12312312);
                }
            },
            getRowSpan() {
                this.rowSpanArr = [];
                this.returnGoods.forEach((item, index) => {
                    if (index == 0) {
                        this.rowSpanArr.push(1);
                        this.position = 0;
                    } else {
                        if (
                            this.returnGoods[index].prepayMoney ==
                            this.returnGoods[index - 1].prepayMoney
                        ) {
                            this.rowSpanArr[this.position] += 1; //项目名称相同，合并到同一个数组中
                            this.rowSpanArr.push(0);
                            this.returnGoods[index].prepayMoney = this.returnGoods[
                            index - 1
                                ].prepayMoney;
                        } else {
                            this.rowSpanArr.push(1);
                            this.position = index;
                        }
                    }
                });
            },
            objectSpanMethod({ rowIndex, columnIndex }) {
                // 只合并区域位置
                if (!this.queryConfigFlag) {
                    if (columnIndex === 8) {
                        const _row = this.rowSpanArr[rowIndex];

                        return {
                            rowspan: _row, //行
                            colspan: 1 //列
                        };
                    }
                }
            },
            async queryConfigRefundAmount() {
                const { result } = await this.$store.dispatch("queryConfigRefundAmount", {
                    code: "refundAmountLimit"
                });
                if (result) {
                    this.queryConfigFlag = result.value === "0" ? true : false;
                } else {
                    this.queryConfigFlag = true;
                }
            },
            isBtn(code) {
                return this.isShowBtn(code);
            },
            filterGt0OrFixed2(prop, index) {
                // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
                this.returnGoods[index][prop] = this.returnGoods[index][prop].replace(
                    /[^\d.]/g,
                    ""
                ); //仅保留数字和"."
                this.returnGoods[index][prop] = this.returnGoods[index][prop].replace(
                    /\.{2,}/g,
                    "."
                ); //两个连续的"."仅保留第一个"."
                this.returnGoods[index][prop] = this.returnGoods[index][prop]
                    .replace(".", "$#*")
                    .replace(/\./g, "")
                    .replace("$#*", "."); //去除其他"."
                this.returnGoods[index][prop] = this.returnGoods[index][prop].replace(
                    /^(\d+)\.(\d\d).*$/,
                    "$1.$2"
                ); //限制只能输入两个小数
                if (
                    this.returnGoods[index][prop].indexOf(".") < 0 &&
                    this.returnGoods[index][prop] != ""
                ) {
                    //首位是0的话去掉
                    this.returnGoods[index][prop] = parseFloat(
                        this.returnGoods[index][prop]
                    );
                }
            },
            switchTabs() {
                this.currentPage = 1;
                this.pageSize = 10;
                this.queryList();
            },
            submitsearchCondition() {
                let batchCondition = JSON.parse(JSON.stringify(this.batchCondition));
                batchCondition.wxshopCategoryId =
                    batchCondition.wxshopCategoryId[
                    batchCondition.wxshopCategoryId.length - 1
                        ];
                batchCondition.spuIdList = this.checkedRow;
                // this.$store.dispatch("batchEdit", batchCondition).then(res => {
                //   if (res.code === "0") {
                //     this.$message({
                //       message: "操作成功",
                //       type: "success"
                //     });
                //     this.queryList();
                //     this.dialogVisible = false;
                //   }
                // });
            },
            addGoods() {
                this.$router.push({ name: "AddMicroShopGoods" });
            },
            openDetails(row) {
                this.orderGoodsId = row.orderGoodsId;
                this.returnSn = row.returnSn;
                this.receiptSn = row.receiptSn;
                this.orderRefundId = row.orderRefundId;
                this.queryOrderRefundRecord();
            },
            async queryReturnGoods() {
                let params = {
                    receiptSn: this.receiptSn,
                    refundMode:'third'
                };

                const { result } = await this.$store.dispatch(
                    "queryReturnGoodsList",
                    params
                );
                this.returnGoods = result;
                this.returnGoods.forEach(v => {
                    v.prepayMoney = this.detailsOrder.order.prepayMoney;
                });
                this.isShowReturnIntegral =
                    this.returnGoods.findIndex(v => v.returnIntegral) > -1;
                this.getRowSpan();
            },
            async queryOrderRefundRecord() {
                let params = {
                    orderRefundId: this.orderRefundId
                };
                const { result } = await this.$store.dispatch(
                    "queryOrderRefundRecordList",
                    params
                );
                const { refundRecordModelList, returnInfo } = result;
                this.refundRecordList = refundRecordModelList;
                this.returnInfo = returnInfo;
                if (returnInfo.status === 1) {
                    this.active = 1;
                    this.disabled = false;
                    this.show = false;
                    this.refundTime = "";
                    this.returnSendTime = returnInfo.returnSendTime;
                    // this.orderSta = "发起申请";
                } else if (returnInfo.status === 2) {
                    this.active = 2;
                    this.disabled = false;
                    this.show = true;
                    this.returnSendTime = returnInfo.returnSendTime;
                    this.refundTime = "";
                    this.returnConfirmTime = returnInfo.returnConfirmTime;
                    // this.orderSta = "核定信息";
                } else if (returnInfo.status === 3) {
                    this.active = 3;
                    this.show = true;
                    this.returnConfirmTime = returnInfo.returnConfirmTime;
                    this.returnSendTime = returnInfo.returnSendTime;
                    this.refundTime = returnInfo.refundTime;
                    // this.orderSta = "退货/退款";
                } else if (returnInfo.status === 4) {
                    this.active = 3;
                    this.disabled = true;
                    this.returnConfirmTime = returnInfo.returnConfirmTime;
                    this.returnSendTime = returnInfo.returnSendTime;
                    this.refundTime = returnInfo.refundTime;
                    // this.orderSta = "退货/退款";
                } else if (returnInfo.status === 8) {
                    this.active = 3;
                    this.disabled = true;
                    this.returnSendTime = returnInfo.returnSendTime;
                    this.returnConfirmTime = returnInfo.returnConfirmTime;
                }
            },
            detailOrder() {
                return this.$store
                    .dispatch("detailOrder", {
                        orderId: this.orderId
                    })
                    .then(res => {
                        let orderSta =
                            res.result.orderStatus[res.result.orderStatus.length - 1];
                        let flag = false;
                        res.result.orderGoods.map(v => {
                            if (v.returnType === "no") {
                                flag = true;
                            }
                        });

                        if (flag) {
                            let listStatus = [];
                            res.result.orderStatus.forEach(v => {
                                if (v.orderStatus !== "returnOrder") {
                                    listStatus.push(v);
                                }
                            });
                            orderSta = listStatus[listStatus.length - 1];
                        }
                        if (orderSta.orderStatus === "createOrder") {
                            // this.active = 1;
                            // this.delOrder = true;
                            // this.disabled = true;
                            // this.delivery = true;
                            this.orderSta = "待付款";
                        } else if (orderSta.orderStatus === "payOrder") {
                            // this.active = 2;
                            // this.delOrder = true;
                            // this.disabled = false;
                            // this.delivery = true;
                            this.orderSta = "待发货";
                        } else if (orderSta.orderStatus === "deliverOrder") {
                            // this.active = 3;
                            // this.delOrder = true;
                            // this.delivery = false;
                            // this.disabled = true;
                            this.orderSta = "已发货";
                        } else if (orderSta.orderStatus === "takeOrder") {
                            // this.active = 4;
                            // this.delOrder = true;
                            // this.delivery = true;
                            // this.disabled = true;
                            this.orderSta = "已收货";
                        } else if (orderSta.orderStatus === "pushOrder") {
                            // this.active = 5;
                            // this.delOrder = true;
                            // this.delivery = true;
                            // this.disabled = true;
                            this.orderSta = "已评价";
                        } else if (orderSta.orderStatus === "delOrder") {
                            // this.delOrder = false;
                            this.orderSta = "已取消";
                        } else if (orderSta.orderStatus === "returnOrder") {
                            // this.delOrder = false;
                            this.orderSta = "有退货退款";
                        }

                        res.result.orderStatus.forEach(v => {
                            if (v.orderStatus === "createOrder") {
                                this.createOrderTime = v.createTime;
                            }
                            if (v.orderStatus === "payOrder") {
                                this.payOrderTime = v.createTime;
                            }
                            if (v.orderStatus === "deliverOrder") {
                                this.deliverOrderTime = v.createTime;
                            }
                            if (v.orderStatus === "takeOrder") {
                                this.takeOrderTime = v.createTime;
                            }
                            if (v.orderStatus === "pushOrder") {
                                this.pushOrderTime = v.createTime;
                            }
                        });
                        this.queryReturnGoods();
                    });
            },
            toDetails(row) {
                this.receiptSn = row.receiptSn;
                this.returnSn = row.returnSn;
                this.orderRefundId = row.orderRefundId;
                this.returnType = row.returnType;
                this.dialogVisible = true;
                this.orderGoodsId = row.orderGoodsId;
                this.orderId = row.orderId;

                this.queryOrderRefundRecord();
                this.detailOrder();
                // this.queryReturnGoods();
                // this.$store
                //   .dispatch("detailsOrderReturn", {
                //     orderRefundId: row.orderRefundId,
                //     receiptSn: row.receiptSn
                //   })
                //   .then(res => {
                //     let orderSta = res.result.returnOrder;
                //     if (orderSta.status === 1) {
                //       this.active = 1;
                //       this.disabled = false;
                //       this.show = false;
                //       this.refundTime = "";
                //       this.returnSendTime = orderSta.returnSendTime;
                //       this.orderSta = "发起申请";
                //     } else if (orderSta.status === 2) {
                //       this.active = 2;
                //       this.disabled = false;
                //       this.show = true;
                //       this.returnSendTime = orderSta.returnSendTime;
                //       this.refundTime = "";
                //       this.returnConfirmTime = orderSta.returnConfirmTime;
                //       this.orderSta = "核定信息";
                //     } else if (orderSta.status === 3) {
                //       this.active = 3;
                //       this.show = true;
                //       this.returnConfirmTime = orderSta.returnConfirmTime;
                //       this.returnSendTime = orderSta.returnSendTime;
                //       this.refundTime = orderSta.refundTime;
                //       this.orderSta = "退货/退款";
                //     } else if (orderSta.status === 4) {
                //       this.active = 3;
                //       this.disabled = true;
                //       this.returnConfirmTime = orderSta.returnConfirmTime;
                //       this.returnSendTime = orderSta.returnSendTime;
                //       this.refundTime = orderSta.refundTime;
                //       this.orderSta = "退货/退款";
                //     } else if (orderSta.status === 8) {
                //       this.active = 3;
                //       this.disabled = true;
                //       this.returnSendTime = orderSta.returnSendTime;
                //       this.returnConfirmTime = orderSta.returnConfirmTime;
                //     }

                //     this.status = orderSta.status;

                //     this.orderGoodsId = orderSta.orderGoodsId;
                //     //   res.result.orderStatus.forEach(v => {
                //     //     if (v.orderStatus === "createOrder") {
                //     //       this.createOrderTime = v.createTime;
                //     //     }
                //     //     if (v.orderStatus === "payOrder") {
                //     //       this.payOrderTime = v.createTime;
                //     //     }
                //     //     if (v.orderStatus === "deliverOrder") {
                //     //       this.deliverOrderTime = v.createTime;
                //     //     }
                //     //     if (v.orderStatus === "takeOrder") {
                //     //       this.takeOrderTime = v.createTime;
                //     //     }
                //     //     if (v.orderStatus === "pushOrder") {
                //     //       this.pushOrderTime = v.createTime;
                //     //     }
                //     //   });
                //   });
            },
            close() {
                this.dialogVisible = false;
                setTimeout(() => {
                    this.resetRuleForm();
                }, 0);
            },
            resetRuleForm() {
                if (this.$refs.ruleForm) {
                    this.$refs.ruleForm.resetFields();
                }
                this.refundAgain = "";
                this.createOrderTime = "";
                this.payOrderTime = "";
                this.deliverOrderTime = "";
                this.takeOrderTime = "";
                this.pushOrderTime = "";
                this.belongShopId = "";
                this.ruleForm.cancelMsg = "";
            },
            handleSizeChange(size) {
                this.currentPage = 1;
                this.pageSize = size;
                this.queryList();
            },
            remove(row, type) {
                this.$confirm(" 删除本行数据?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    let actionName = "deleteGoods";
                    let params = {
                        spuId: row.spuId
                    };
                    if (type) {
                        actionName = "batchEdit";
                        params = {
                            spuIdList: row,
                            delFlag: 1
                        };
                    }
                    this.$store.dispatch(actionName, params).then(res => {
                        if (res.code === "0") {
                            this.$message({
                                message: " 操作成功",
                                type: "success"
                            });
                            this.queryList();
                        }
                    });
                });
            },
            output() {
                require.ensure([], () => {
                    const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
                    this.isOutputing = true;
                    this.queryList("queryAll")
                        .then(res => {
                            const list = this.tableData;
                            list.forEach(v => {
                                v.haha = "售后申请";
                                if (v.returnType == "money") {
                                    v.returnType = "仅退款";
                                } else if (v.returnType == "refund") {
                                    v.returnType = "退货退款";
                                } else if (v.returnType == "deliver") {
                                    v.returnType = "退运费";
                                }
                                if (v.status == "1") {
                                    v.status = "已提交";
                                } else if (v.status == "2") {
                                    v.status = "已审核";
                                } else if (v.status == "3") {
                                    v.status = "已退货待退款";
                                } else if (v.status == "4") {
                                    v.status = "已退款";
                                } else if (v.status == "8") {
                                    v.status = "已驳回";
                                } else if (v.status == "9") {
                                    v.status = "已取消";
                                }
                            });
                            console.log("list",list);

                            const tHeader = [
                                "退款编码",
                                "退款方式",
                                "订单编号",
                                "订单生成时间",
                                "会员姓名",
                                "会员手机",
                                "商品名称",
                                "商品编码",
                                "商品条码",
                                "申请退款金额",
                                "核定退款金额",
                                "申请时间",
                                "退款申请人",
                                "运费退款申请",
                                "运费退款核定",
                                "退款时间",
                                "退款人",
                                "退款状态",
                                "退款类型",
                                "所属门店"
                            ];
                            const filterVal = [
                                "returnSn",
                                "returnType",
                                "receiptSn",
                                "orderCreateTime",
                                "memberName",
                                "memberMobile",
                                "spuName",
                                "goodsSn",
                                "barCode",
                                "returnAmount",
                                "confirmReturnAmount",
                                "returnSendTime",
                                "operationName",
                                "returnDeliverMoney",
                                "confirmReturnDeliverMoney",
                                "refundTime",
                                "refundOperator",
                                "status",
                                "haha",
                                "shopName"
                            ];
                            const data = this.formatJson(filterVal, list);
                            exportJsonToExcel(
                                tHeader,
                                data,
                                "售后订单" + new Date().toLocaleString()
                            );
                            this.isOutputing = false;
                        })
                        .catch(() => {
                            this.isOutputing = false;
                        });
                });
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]));
            },
            switchAuditState(id, enabledState) {
                this.$store
                    .dispatch("switchAuditState", {
                        enabledState,
                        id
                    })
                    .then(() => {
                        this.queryList();
                    });
            },
            addActivity() {
                this.$router.push({
                    name: "SelectActivity"
                });
            },
            paging(page) {
                this.currentPage = page;
                this.queryList();
            },
            isArray(arr) {
                return Object.prototype.toString.call(arr) === "[object Array]";
            },
            tableRowClassName({ row }) {
                if (row.returnSn === this.returnSn) {
                    return "tuikuan";
                }
                return "";
            },
            tableRowClassNames({ row }) {
                if (row.returnType !== "no") {
                    return "tuikuan";
                }
                return "";
            },
            async doubleReject() {
                let params = {
                    orderRefundId: this.orderRefundId,
                    confirmReturnAmount: this.confirmReturnAmount,
                    confirmReturnDeliverMoney: this.confirmReturnDeliverMoney,
                    confirmReturnPrepayCardMoney: this.confirmReturnPrepayCardMoney,
                    returnIntegral: this.returnIntegral,
                    confirmReturnIntegral: this.confirmReturnIntegral,
                    status: this.status,
                    receiptSn: this.receiptSn,
                    orderGoodsId: this.orderGoodsId,
                    centerId: this.detailsOrder.order.centerId,
                    isConfirm: "yes"
                };
                Object.assign(params, this.ruleForm);
                const { code, result, inMsg, errMsg } = await this.$store.dispatch(
                    "orderReturnUpd",
                    params
                );

                if (code === "0") {
                    this.detailsVisible = false;
                    this.prepayCardUsedVisible = false;
                    if (result === "error") {
                        this.$message({
                            message: "该商品已经核定售后金额",
                            type: "warning"
                        });
                    } else if (inMsg === "prepayCardUsed") {
                        //储值卡已被使用过
                        this.prepayCardUsedVisible = true;
                        this.prepayCardUsedErrmag = errMsg;
                        this.memberRelModelList = result.memberRelModelList;
                        setTimeout(() => {
                            this.$message({
                                message: errMsg,
                                type: "warning"
                            });
                        }, 10);
                        return;
                    } else {
                        this.$message({
                            message: "操作成功",
                            type: "success"
                        });
                    }

                    setTimeout(() => {
                        this.resetRuleForm();
                    }, 0);
                    this.queryList();
                    this.queryOrderRefundRecord();
                    this.detailOrder();
                    // this.queryReturnGoods();
                }
            },
            reject(formName) {
                // this.$refs.textarea.focus();
                document.getElementById("btn").blur();
                console.log("this.status: ", this.status);
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        if (this.status <= 4) {
                            let params = {
                                orderRefundId: this.orderRefundId,
                                confirmReturnAmount: this.confirmReturnAmount,
                                confirmReturnDeliverMoney: this.confirmReturnDeliverMoney,
                                confirmReturnPrepayCardMoney: this.confirmReturnPrepayCardMoney,
                                returnIntegral: this.returnIntegral,
                                confirmReturnIntegral: this.confirmReturnIntegral,
                                status: this.status,
                                receiptSn: this.receiptSn,
                                orderGoodsId: this.orderGoodsId,
                                centerId: this.detailsOrder.order.centerId
                            };
                            if (this.refundAgain === "yes") {
                                params.refundAgain = "yes";
                            }
                            Object.assign(params, this.ruleForm);
                            return this.$store.dispatch("orderReturnUpd", params).then(res => {
                                const { code, result, inMsg, errMsg } = res;
                                if (code === "0") {
                                    this.detailsVisible = false;
                                    if (result === "error") {
                                        this.$message({
                                            message: "该商品已经核定售后金额",
                                            type: "warning"
                                        });
                                    } else if (inMsg === "prepayCardUsed") {
                                        //储值卡已被使用过
                                        this.prepayCardUsedVisible = true;
                                        this.prepayCardUsedErrmag = errMsg;
                                        this.memberRelModelList = result.memberRelModelList;
                                        setTimeout(() => {
                                            this.$message({
                                                message: errMsg,
                                                type: "warning"
                                            });
                                        }, 10);
                                        return;
                                    } else {
                                        this.$message({
                                            message: "操作成功",
                                            type: "success"
                                        });
                                    }

                                    setTimeout(() => {
                                        this.resetRuleForm();
                                    }, 0);
                                    this.queryList();
                                    this.queryOrderRefundRecord();
                                    this.detailOrder();
                                    // this.queryReturnGoods();
                                }
                            });
                        } else {
                            let params = {
                                orderRefundId: this.orderRefundId,
                                status: this.status,
                                confirmReturnPrepayCardMoney: this.confirmReturnPrepayCardMoney,
                                confirmReturnDeliverMoney: this.confirmReturnDeliverMoney,
                                confirmReturnAmount: this.confirmReturnAmount,
                                confirmReturnIntegral: this.confirmReturnIntegral
                            };
                            Object.assign(params, this.ruleForm);
                            return this.$store.dispatch("orderReturnUpd", params).then(res => {
                                if (res.code === "0") {
                                    this.detailsVisible = false;
                                    if (res.result === "error") {
                                        this.$message({
                                            message: "该商品已审核！",
                                            type: "warning"
                                        });
                                    } else {
                                        this.$message({
                                            message: "操作成功",
                                            type: "success"
                                        });
                                    }

                                    setTimeout(() => {
                                        this.resetRuleForm();
                                    }, 0);
                                    this.queryList();

                                    this.queryOrderRefundRecord();
                                    this.detailOrder();
                                }
                            });
                        }
                    } else {
                        return false;
                    }
                });
            },
            async undo(row) {
                const { code } = await this.$store.dispatch("cancleRefundInfo", {
                    orderGoodsId: row.orderGoodsId,
                    orderRefundId: row.orderRefundId
                });
                if (code === "0") {
                    this.$message({
                        message: "操作成功",
                        type: "success"
                    });
                    this.queryList();
                    this.dialogVisible = false;
                }
            },
            bohui(index) {
                if (!this.returnGoods[index].confirmReturnAmount) {
                    this.confirmReturnAmount = 0;
                } else {
                    this.confirmReturnAmount = this.returnGoods[index].confirmReturnAmount;
                }

                this.confirmReturnDeliverMoney =
                    this.returnGoods[index].confirmReturnDeliverMoney === ""
                        ? 0
                        : this.returnGoods[index].confirmReturnDeliverMoney;
                this.confirmReturnPrepayCardMoney =
                    this.returnGoods[index].confirmReturnPrepayCardMoney === ""
                        ? 0
                        : this.returnGoods[index].confirmReturnPrepayCardMoney;

                this.returnIntegral = +this.returnGoods[index].returnIntegral || 0;
                this.confirmReturnIntegral =
                    +this.returnGoods[index].confirmReturnIntegral || 0;
                this.detailsVisible = true;
                this.status = 8;
            },
            jixu(index) {
                this.refundAgain = "yes";
                this.refundAgainAmount = this.returnGoods[index].confirmReturnAmount;
                this.returnGoods[index].status = 1;
                this.returnGoods[index].returnAmount = formatFloat(
                    this.returnGoods[index].returnAmount -
                    this.returnGoods[index].confirmReturnAmount,
                    2
                );
                this.returnGoods[index].confirmReturnAmount = JSON.parse(
                    JSON.stringify(this.returnGoods[index].returnAmount)
                );
                this.returnGoods[index].returnDeliverMoney = formatFloat(
                    this.returnGoods[index].returnDeliverMoney -
                    this.returnGoods[index].confirmReturnDeliverMoney,
                    2
                );
                this.returnGoods[index].confirmReturnDeliverMoney = JSON.parse(
                    JSON.stringify(this.returnGoods[index].returnDeliverMoney)
                );
            },
            consent(index) {
                if (this.queryConfigFlag) {
                    if (
                        (this.returnGoods[index].returnType !== "deliver" &&
                            this.returnGoods[index].confirmReturnAmount === "") ||
                        this.returnGoods[index].confirmReturnDeliverMoney === ""
                    ) {
                        this.$message({
                            message: "请填写确认退款金额",
                            type: "warning"
                        });
                    } else {
                        if (
                            +this.returnGoods[index].confirmReturnAmount >
                            +this.returnGoods[index].returnAmount ||
                            +this.returnGoods[index].confirmReturnDeliverMoney >
                            +this.returnGoods[index].returnDeliverMoney ||
                            +this.returnGoods[index].confirmReturnPrepayCardMoney >
                            +this.returnGoods[index].returnPrepayCardMoney
                        ) {
                            this.$message({
                                message: "退款金额不能大于实付金额",
                                type: "warning"
                            });
                        } else {
                            if (
                                +this.returnGoods[index].confirmReturnAmount < 0 ||
                                +this.returnGoods[index].confirmReturnDeliverMoney < 0 ||
                                +this.returnGoods[index].confirmReturnPrepayCardMoney < 0
                            ) {
                                this.$message({
                                    message: "请输入大于0的金额",
                                    type: "warning"
                                });
                            } else {
                                this.confirmReturnAmount = +this.returnGoods[index]
                                    .confirmReturnAmount;
                                this.confirmReturnDeliverMoney = +this.returnGoods[index]
                                    .confirmReturnDeliverMoney;
                                this.confirmReturnPrepayCardMoney = +this.returnGoods[index]
                                    .confirmReturnPrepayCardMoney;
                                this.returnIntegral = +this.returnGoods[index].returnIntegral;
                                this.confirmReturnIntegral = +this.returnGoods[index]
                                    .confirmReturnIntegral;
                                if (this.returnGoods[index].status == 1) {
                                    this.status = 2;
                                } else if (this.returnGoods[index].status == 2) {
                                    this.status = 4;
                                }
                                // if (this.returnType === "money") {
                                //   if (this.returnGoods[index].status == 1) {
                                //     this.status = 2;
                                //   } else if (this.returnGoods[index].status == 2) {
                                //     this.status = 4;
                                //   }
                                // } else if (this.returnType === "refund") {
                                //   if (this.returnGoods[index].status == 1) {
                                //     this.status = 2;
                                //   } else if (this.returnGoods[index].status == 2) {
                                //     this.status = 4;
                                //   }
                                // }
                                this.detailsVisible = true;
                            }
                        }
                    }
                } else {
                    if (
                        (this.returnGoods[index].returnType !== "deliver" &&
                            this.returnGoods[index].confirmReturnAmount === "") ||
                        this.returnGoods[index].confirmReturnDeliverMoney === ""
                    ) {
                        this.$message({
                            message: "请填写确认退款金额",
                            type: "warning"
                        });
                    } else {
                        let goodsTotal = 0;
                        let prepayCardTotal = 0;
                        this.returnGoods.forEach(v => {
                            if (v.status !== 8) {
                                goodsTotal += v.confirmReturnAmount * 1;
                                prepayCardTotal += v.confirmReturnPrepayCardMoney * 1;
                            }
                        });
                        goodsTotal = goodsTotal.toFixed(2);
                        prepayCardTotal = prepayCardTotal.toFixed(2);
                        let goodsLimit = (
                            this.detailsOrder.order.actuallyPrice -
                            (this.detailsOrder.order.deliverMoney -
                                this.detailsOrder.order.deliverCouponMoney)
                        ).toFixed(2);

                        if (this.refundAgain === "yes") {
                            goodsLimit = formatFloat(
                                goodsLimit - this.refundAgainAmount,

                                2
                            );
                        }
                        console.log("goodsLimit: ", goodsLimit);
                        console.log("goodsTotal: ", goodsTotal);
                        if (
                            new Number(goodsTotal) > new Number(goodsLimit) ||
                            prepayCardTotal > this.detailsOrder.order.prepayMoney ||
                            this.returnGoods[index].confirmReturnDeliverMoney >
                            +this.returnGoods[index].returnDeliverMoney
                        ) {
                            this.$message({
                                message: "退款金额不能大于实付金额",
                                type: "warning"
                            });
                        } else {
                            if (
                                +this.returnGoods[index].confirmReturnAmount < 0 ||
                                +this.returnGoods[index].confirmReturnDeliverMoney < 0 ||
                                +this.returnGoods[index].confirmReturnPrepayCardMoney < 0
                            ) {
                                this.$message({
                                    message: "请输入大于0的金额",
                                    type: "warning"
                                });
                            } else {
                                this.confirmReturnAmount = +this.returnGoods[index]
                                    .confirmReturnAmount;
                                this.confirmReturnDeliverMoney = +this.returnGoods[index]
                                    .confirmReturnDeliverMoney;
                                this.confirmReturnPrepayCardMoney = +this.returnGoods[index]
                                    .confirmReturnPrepayCardMoney;
                                this.returnIntegral = +this.returnGoods[index].returnIntegral;
                                this.confirmReturnIntegral = +this.returnGoods[index]
                                    .confirmReturnIntegral;
                                if (this.returnGoods[index].status == 1) {
                                    this.status = 2;
                                } else if (this.returnGoods[index].status == 2) {
                                    this.status = 4;
                                }
                                // if (this.returnType === "money") {
                                //   if (this.returnGoods[index].status == 1) {
                                //     this.status = 2;
                                //   } else if (this.returnGoods[index].status == 2) {
                                //     this.status = 4;
                                //   }
                                // } else if (this.returnType === "refund") {
                                //   if (this.returnGoods[index].status == 1) {
                                //     this.status = 2;
                                //   } else if (this.returnGoods[index].status == 2) {
                                //     this.status = 4;
                                //   }
                                // }
                                this.detailsVisible = true;
                            }
                        }
                    }
                }
            },
            async queryList(queryAll) {
                const params = {
                    pageSize: queryAll ? 99999 : this.pageSize,
                    pageNo: queryAll ? 1 : this.currentPage,
                    refundMode:'third'
                };
                const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
                searchCondition.starTime = this.isArray(searchCondition.applyDate)
                    ? searchCondition.applyDate[0]
                    : "";
                searchCondition.endTime = this.isArray(searchCondition.applyDate)
                    ? searchCondition.applyDate[1]
                    : "";

                // searchCondition.attributeId = this.isArray(searchCondition.attributeId)
                //   ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
                //   : "";
                Object.assign(params, searchCondition);
                this.setParamsCookie();

                // const actionName = queryAll
                //     ? "queryALLOrderReturnList"
                //     : "queryOrderReturnList";
                const { result } = await this.$store.dispatch("third_order_refund_list", params);
                this.waitStatus = result;
                this.tableData = result.page.records;
                this.total = result.page.total;
                console.log('this.tableData',this.tableData)
            },
            setParamsCookie() {
                setCookie({
                    key: "afterSaleListParams",
                    type: "session",
                    data: Object.assign({}, this.searchCondition, {
                        pageSize: this.pageSize,
                        currentPage: this.currentPage
                    })
                });
            },
            getParamsCookie() {
                const prams = getCookie({ key: "afterSaleListParams", type: "session" });
                if (prams) {
                    let search = {};
                    for (let key in prams) {
                        if (key !== "pageSize" && key !== "currentPage") {
                            search[key] = prams[key];
                        }
                    }
                    this.searchCondition = search;
                    this.searchCondition.queryTimeType =
                        this.searchCondition.queryTimeType === "refundTime"
                            ? "refundTime"
                            : "returnSendTime";
                    this.pageSize = prams.pageSize;
                    this.currentPage = prams.currentPage;
                }
            },
            getChecked(selection) {
                this.checkedRow = selection.map(v => v.spuId);
            },
            batchSetting() {
                if (this.checkedRow.length) {
                    this.dialogVisible = true;
                } else {
                    this.$message({
                        message: "请选择",
                        type: "warning"
                    });
                }
            },
            batchDelete() {
                if (this.checkedRow.length) {
                    this.remove(this.checkedRow, "batch");
                } else {
                    this.$message({
                        message: "请选择",
                        type: "warning"
                    });
                }
            },
            search() {
                this.currentPage = 1;
                this.queryList();
            }
        }
    };
</script>
<style lang="scss">
    .micro-goods-list {
        .el-tabs__header {
            background: #f4f4f4;
        }
    }

    .el-table .tuikuan {
        background: rgba(255, 240, 240, 1);
        border: 1px solid rgba(255, 0, 0, 1);
        z-index: 9999999;
    }
    .content {
        .el-step.is-center .el-step__description {
            padding: 0;
        }
    }
</style>
<style scoped lang="scss">
    .only-tuikuan {
        opacity: 0.3;
        // background: rgba(255, 255, 255, 1);
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }

    .tuikuan {
        background: rgba(255, 240, 240, 1);
        border: 1px solid rgba(255, 0, 0, 1);
        z-index: 9999999;
    }
    .warning-tuikuan {
        position: absolute;
        left: 0;
        top: 0;
    }
    .table-panel {
        font-size: 12px;
        .line {
            color: #dcdfe6;
            margin: 0 5px;
        }
    }
    .batch {
        div {
            margin: 20px 0;
            cursor: pointer;
            font-size: 14px;
            color: #222222;
            user-select: none;
            &:first-child {
                margin-right: 20px;
            }
        }
        .hmicon {
            margin-right: 5px;
        }
    }

    .tabs {
        .first-tip {
            padding-left: 30px;
            margin-bottom: 20px;
            .title {
                padding-left: 0;
            }
        }
        .title {
            color: #222222;
            padding-left: 10px;
        }
        .form-item-tip {
            font-size: 12px;
        }
    }
    .form-item-tip {
        color: #999;
        font-size: 14px;
    }

    .content {
        margin: -20px;
        .progress {
            background: #f7f7f7;
            padding: 20px 0;
        }
    }
    .info-list {
        // padding: 0 20px;
    }
    .info-list,
    .logistics-list {
        .title {
            margin-bottom: 20px;
            &::before {
                display: inline-block;
                margin-right: 10px;
                content: "";
                width: 4px;
                height: 12px;
                background: #e50065;
                border-top-left-radius: 30px;
                border-bottom-right-radius: 30px;
            }
        }
    }

    .content-item {
        line-height: 25px;
        color: #222;
        .info {
            color: #666666;
        }
    }
</style>
